import React from "react";
import "./PhotographyItem.css";
import { Link } from "react-router-dom";
import ReactGA from "react-ga";
import data from "../../data.json";
import { GithubIcon, LiveIcon } from "../../images/icons/icons";
import PageNotFound from "../PageNotFound/PageNotFound";
import Fade from "react-reveal/Fade";

const PhotographyItem = ({ closeNav, match }) => {
	const slug = match.params.slug;
	const picture = data.pictures[slug];
	const isMobile = picture?.device_type === "mobile";

	if (!picture) {
		return <PageNotFound />;
	}

	return (
		<div className="photography-item">
			<header className="photography-item__header">
				<Link
					to="/photography"
					className="photography-item__path photography-item__path--link"
				>
					Photography
				</Link>

				<span className="photography-item__path-separator">{">"}</span>
				<span className="photography-item__path">{picture.name}</span>
			</header>
			<main className="photography-item__body">
				<Fade bottom>
					<div
						className={`photography-item__img-wrapper ${
							isMobile ? "photography-item__img-wrapper--mobile" : ""
						}`}
					>
						<a
							className="device-wrapper"
							href={picture.gif_url || picture.image_url}
							target="_blank"
						>
							<div
								className="device tooltip"
								data-device={isMobile ? "iPhone6" : "Macbook2015"}
								data-orientation="portrait"
								data-color={isMobile ? "white" : "gold"}
							>
								<div className="screen">
									<span class="tooltip__text tooltip__text--bottom">
										Click to view fullscreen
									</span>
									<img
										src={
											picture.gif_url ||
											picture.device_image_url ||
											picture.image_url
										}
										alt={picture.name}
										className="photography-item__img"
									/>
								</div>
							</div>
						</a>
					</div>
				</Fade>{" "}
				<div className="photography-item__content">
					<Fade bottom>
						<h2 className="photography-item__heading"> {picture.name}</h2>
						<p
							className="photography-item__summary"
							dangerouslySetInnerHTML={{ __html: picture.description }}
						/>
						<div className="photography-item__link-wrapper">
							{picture.github_url ? (
								<ReactGA.OutboundLink
									eventLabel="Clicked github link for photography item"
									to={picture.github_url}
									target="_blank"
									className="photography-item__link photography-item__link--github"
								>
									<GithubIcon
										width={20}
										className="photography-item__link-icon"
									/>{" "}
									View on Github
								</ReactGA.OutboundLink>
							) : (
								<a />
							)}
							{picture.live_url ? (
								<ReactGA.OutboundLink
									eventLabel="Clicked live link for photography item"
									to={picture.live_url}
									className="photography-item__link photography-item__link--live"
									target="_blank"
								>
									<LiveIcon width={20} className="photography-item__link-icon" />{" "}
									View Live
								</ReactGA.OutboundLink>
							) : (
								<a />
							)}
						</div>
					</Fade>
				</div>
			</main>
		</div>
	);
};

export default PhotographyItem;
